// @ts-nocheck
import OrionError from '../error/OrionError'
import { getLodop } from './LodopFuncs'

export function lodopInit() {
  // 获取lodop
  const LODOP = getLodop()

  return new Promise((resolve) => {
    resolve(LODOP)
  })
}

// 获取打印机列表
export function getPrinterList() {
  lodopInit()
  const printers = []
  const count = LODOP.GET_PRINTER_COUNT()
  for (let i = 0; i < count; i++) {
    printers.push({
      value: i,
      content: LODOP.GET_PRINTER_NAME(i),
    })
  }

  return printers
}

// 获取打印机名称列表
export function getPrinterNameList() {
  lodopInit()
  const printers = []
  const count = LODOP.GET_PRINTER_COUNT()
  for (let i = 0; i < count; i++) {
    const prname = LODOP.GET_PRINTER_NAME(i)
    printers.push({
      value: prname,
      content: prname,
    })
  }

  return printers
}

//////////////////////////////////// 接口

// 获取默认打印机名称
export async function getDefaultPrinter() {
  const LODOP = await lodopInit()
  return LODOP.GET_PRINTER_NAME(-1) // 获取默认打印机名称(-1是指定默认打印机)
}

export interface PrintParaI {
  direction?: 1 | 2 | 3 | 0 // 1纵向；2横向；3纵向，高度自适应；0方向不定
  page_width?: number // 纸张宽度，默认为0
  page_height?: number // 纸张高度，默认为0
  page_type?: string // 纸张类型
  print_duplex?: 0 | 1 | 2 | 3 // 双面打印，默认为0 0-不控制 1-不双面 2-双面(长边装订) 3-小册子双面(短边装订_长边水平)
  print_defaultsource?: 0 | 1 | 4 | 7 // 双面打印方式，默认为0 1-纸盒 4-手动 7-自动 0-不控制
  print_mode_map?: {
    // 扩展接口，打印第三方文件时可能需要调优，参数可参考lodop官方文档的LODOP.SET_PRINT_MODE方法
    PRINT_PAGE_PERCENT: string // 指定整页缩放打印的比例 格式为Full-Width | Full-Height | Full-Page | “Width:XX%;Height:XX%”
  }
}

// 无打印模板，预览打印
export async function preview(params: { pdfurl: string; print_para?: PrintParaI }) {
  if (!params) {
    throw new OrionError('打印异常：入参为空，请检查')
  }

  const { pdfurl, print_para = {} } = params

  if (!pdfurl) {
    throw new OrionError('打印异常：未知的文件地址[' + pdfurl + ']，无法进行打印')
  }

  const LODOP = await lodopInit()

  //获取传入的打印参数
  let page_width = 0
  if (print_para.page_width != 0 && typeof print_para.page_width != 'undefined') {
    page_width = print_para.page_width
  }
  let page_height = 0
  if (print_para.page_height != 0 && typeof print_para.page_height != 'undefined') {
    page_height = print_para.page_height
  }
  let page_type = ''
  if (print_para.page_type) {
    page_type = print_para.page_type
  }
  let direction = 1
  if (print_para.direction) {
    direction = print_para.direction
  }
  let print_duplex = 0
  if (print_para.print_duplex) {
    print_duplex = print_para.print_duplex
  }
  let print_defaultsource = 0
  if (print_para.print_defaultsource) {
    print_defaultsource = print_para.print_defaultsource
  }

  // 历史问题，防止重复打印的问题
  LODOP.PRINT_INIT('')

  if (print_para.print_mode_map) {
    Object.keys(print_para.print_mode_map).map((item) => {
      LODOP.SET_PRINT_MODE(item, print_para.print_mode_map[item])
    })
  }
  LODOP.SET_PRINT_MODE('PRINT_DUPLEX', print_duplex ? print_duplex : 0)
  LODOP.SET_PRINT_MODE('PRINT_DEFAULTSOURCE', print_defaultsource ? print_defaultsource : 0)
  LODOP.SET_PRINT_PAGESIZE(direction, page_width, page_height, page_type)
  LODOP.ADD_PRINT_PDF(0, 0, '100%', '100%', new URL(pdfurl, import.meta.url))
  LODOP.SET_SHOW_MODE('HIDE_PAPER_BOARD', true) // 移除预览的线条
  LODOP.SET_PREVIEW_WINDOW(0, 0, 0, 0, 0, '预览查看.开始打印') // 适高，工具条，弹出选择打印机，窗口宽，窗口高，窗口名
  LODOP.SET_PRINT_MODE('CATCH_PRINT_STATUS', true) //返回打印机状态

  return new Promise((resolve) => {
    LODOP.On_Return = function (TaskID, Value) {
      resolve(Value)
    }
    LODOP.PREVIEW()
  })
}

export async function print(params: { pdfurl: string; print_para?: PrintParaI; printer?: string | -1 }) {
  if (!params) {
    throw new OrionError('打印异常：入参为空，请检查')
  }

  const { pdfurl, print_para = {}, printer } = params

  if (!pdfurl) {
    throw new OrionError('打印异常：未知的文件地址[' + pdfurl + ']，无法进行打印')
  }

  if (printer) {
    return await printWithCertainPrinter(pdfurl, print_para, printer)
  } else {
    // 没设置打印机
    return await printNeedSelectPrinter(pdfurl, print_para)
  }
}

async function printWithCertainPrinter(pdfurl: string, print_para: PrintParaI = {}, pr_name: string | -1) {
  if (!pdfurl) {
    throw new OrionError('打印异常：未知的文件地址[' + pdfurl + ']，无法进行打印')
  }
  if (!pr_name) {
    throw new OrionError('打印异常：未设置打印机，无法进行打印')
  }

  //获取传入的打印参数
  let page_width = 0
  if (print_para.page_width != 0 && typeof print_para.page_width != 'undefined') {
    page_width = print_para.page_width
  }
  let page_height = 0
  if (print_para.page_height != 0 && typeof print_para.page_height != 'undefined') {
    page_height = print_para.page_height
  }
  let page_type = ''
  if (print_para.page_type) {
    page_type = print_para.page_type
  }
  let direction = 1
  if (print_para.direction) {
    direction = print_para.direction
  }
  let print_duplex = 0
  if (print_para.print_duplex) {
    print_duplex = print_para.print_duplex
  }
  let print_defaultsource = 0
  if (print_para.print_defaultsource) {
    print_defaultsource = print_para.print_defaultsource
  }

  const LODOP = await lodopInit()
  // 指定打印设备（打印机）
  LODOP.PRINT_INIT('')
  // 设置了打印机
  if (pr_name === -1) {
    LODOP.SET_PRINTER_INDEXA(LODOP.GET_PRINTER_NAME(-1))
  } else {
    LODOP.SET_PRINTER_INDEXA(pr_name)
  }
  LODOP.SET_PRINT_PAGESIZE(direction, page_width, page_height, page_type)
  if (print_para.print_mode_map) {
    Object.keys(print_para.print_mode_map).map((item) => {
      LODOP.SET_PRINT_MODE(item, print_para.print_mode_map[item])
    })
  }
  LODOP.SET_PRINT_MODE('PRINT_DUPLEX', print_duplex ? print_duplex : 0)
  LODOP.SET_PRINT_MODE('PRINT_DEFAULTSOURCE', print_defaultsource ? print_defaultsource : 0)
  LODOP.ADD_PRINT_PDF(0, 0, '100%', '100%', new URL(pdfurl, import.meta.url))
  LODOP.SET_PRINT_MODE('CATCH_PRINT_STATUS', true) //返回打印机状态

  return new Promise((resolve) => {
    LODOP.On_Return = function (TaskID, Value) {
      resolve(Value)
    }
    LODOP.PRINT()
  })
}

// 无打印模板，直接打印，需要选择打印机
export async function printNeedSelectPrinter(url: string, print_para: PrintParaI = {}) {
  if (url === null || url === '' || typeof url === 'undefined') {
    throw new OrionError('打印异常：未知的文件地址[' + url + ']，无法进行打印')
  }

  const LODOP = await lodopInit()

  //获取传入的打印参数
  let page_width = 0
  if (print_para.page_width != 0 && typeof print_para.page_width != 'undefined') {
    page_width = print_para.page_width
  }
  let page_height = 0
  if (print_para.page_height != 0 && typeof print_para.page_height != 'undefined') {
    page_height = print_para.page_height
  }
  let page_type = ''
  if (print_para.page_type) {
    page_type = print_para.page_type
  }
  let direction = 1
  if (print_para.direction) {
    direction = print_para.direction
  }
  let print_duplex = 0
  if (print_para.print_duplex) {
    print_duplex = print_para.print_duplex
  }
  let print_defaultsource = 0
  if (print_para.print_defaultsource) {
    print_defaultsource = print_para.print_defaultsource
  }

  // 历史问题，防止重复打印的问题
  LODOP.PRINT_INIT('')

  if (print_para.print_mode_map) {
    Object.keys(print_para.print_mode_map).map((item) => {
      LODOP.SET_PRINT_MODE(item, print_para.print_mode_map[item])
    })
  }

  LODOP.SET_PRINT_MODE('PRINT_DUPLEX', print_duplex ? print_duplex : 0)
  LODOP.SET_PRINT_MODE('PRINT_DEFAULTSOURCE', print_defaultsource ? print_defaultsource : 0)
  LODOP.SET_PRINT_PAGESIZE(direction, page_width, page_height, page_type)
  LODOP.ADD_PRINT_PDF(0, 0, '100%', '100%', url)
  LODOP.SET_SHOW_MODE('HIDE_PAPER_BOARD', true) // 移除预览的线条
  LODOP.SET_PREVIEW_WINDOW(0, 0, 0, 0, 0, '预览查看.开始打印') // 适高，工具条，弹出选择打印机，窗口宽，窗口高，窗口名

  //返回打印机状态
  LODOP.SET_PRINT_MODE('CATCH_PRINT_STATUS', true)

  return new Promise((resolve) => {
    LODOP.On_Return = function (TaskID, Value) {
      resolve(Value)
    }
    LODOP.PRINTA()
  })
}
